var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({key:_vm.key,class:_vm.marginTop?'mt-4':'pt-1',attrs:{"value":_vm.internalValue,"label":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-messages":_vm.errorMessage,"rules":_vm.validationRules,"g-mask":"integer"},on:{"input":_vm.handleInput,"blur":_vm.handleBlur}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }